import React from "react";
import {ImageLoading} from "./Image";
import SelectButtonLoading from "@components/Booking/LocationSelection/LocationRow/Contents/SelectButton/SelectButtonLoading";
import {LocationInfoLoading} from "@components/Booking/LocationSelection/LocationRow/Contents/LocationInfo";

const ContentsLoading = () => {
  return (
    <>
      <ImageLoading />
      <LocationInfoLoading />
      <SelectButtonLoading />
    </>
  );
};

export default React.memo(ContentsLoading);
